// src/components/gauges/GaugeBase.jsx
import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";

export default function GaugeBase({
  value = null,
  unit = "°C",
  color = "#9e9e9e",
  statusLabel = "—",
}) {
  const safeValue =
    typeof value === "number" && Number.isFinite(value) ? value : null;

  const displayValue = safeValue !== null ? safeValue.toFixed(1) : "—";
  const displayColor = color || "#9e9e9e";

  return (
    <Stack spacing={1} alignItems="center" sx={{ p: 1.5 }}>
      {/* ✅ FULL ring siempre */}
      <Box sx={{ position: "relative", width: 150, height: 150 }}>
        {/* Track gris */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={135}
          thickness={5}
          sx={{
            color: "#e0e0e0",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />

        {/* Anillo color FULL */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={135}
          thickness={5}
          sx={{
            color: displayColor,
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />

        {/* Texto centro (misma vibra/size que antes) */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            transform: "translate(-2px, -2px)",
          }}
        >
          <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
            {displayValue} {unit}
          </Typography>
        </Box>
      </Box>

      {/* Estado abajo */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          color: safeValue !== null ? displayColor : "text.secondary",
          textAlign: "center",
          minHeight: 20,
        }}
      >
        {safeValue !== null
          ? statusLabel
            ? `${statusLabel} (${displayValue} ${unit})`
            : `${displayValue} ${unit}`
          : "Sin dato"}
      </Typography>
    </Stack>
  );
}
